import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { News } from '../models';

export const newsActions = createActionGroup({
    events: {
        'Get news': emptyProps(),
        'Get news success': props<{ news: News[] }>(),
        'Get news error': emptyProps(),

        Clear: emptyProps(),
    },
    source: 'News',
});
